import { useState, forwardRef, useMemo } from 'react';
import { SelectInput } from '../../SelectInput';
import { Box } from '../../Box';
import { idBuilder } from '../../internal';

/** Component enables the user to select a specific page size from a range of size.  */
import { jsx as _jsx } from "react/jsx-runtime";
export const PageSize = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    pageSize,
    defaultPageSize = 10,
    pageSizeOptions = [10, 20, 50, 100],
    disabled = false,
    onShowSizeChange,
    size,
    width = 150,
    ...rest
  } = _ref;
  const [pageSizeState, setpageSizeState] = useState(defaultPageSize);
  const sizeOptions = useMemo(() => {
    return pageSizeOptions.map(item => {
      return {
        value: item.toString(),
        label: `${item} / page`
      };
    });
  }, [pageSizeOptions]);
  const handleOnChange = e => {
    setpageSizeState(Number(e.target?.value));
    if (onShowSizeChange) {
      onShowSizeChange(e.target?.value);
    }
  };
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: typeof width === 'string' ? width : `${width}px`
    },
    children: /*#__PURE__*/_jsx(SelectInput, {
      onChange: handleOnChange,
      value: (pageSize || pageSizeState).toString(),
      options: sizeOptions,
      displayDeselectOption: false,
      disabled: disabled,
      displayLabel: false,
      size: size,
      id: id ? idBuilder('ids-page-size', id) : undefined,
      "data-testid": rest['data-testid'] ? idBuilder('ids-page-size', rest['data-testid']) : undefined
    })
  });
});
PageSize.displayName = 'PageSize';